import merge from "lodash/merge";
import api from "./api";
import config from "../config";

export default {
  fetchCredits(person) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `people/self/credits`,
          qs: { event_bucket: config.event_bucket, token: person }
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/CreditUtil.js